import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=d18913de&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d18913de')) {
      api.createRecord('d18913de', component.options)
    } else {
      api.reload('d18913de', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=d18913de&", function () {
      api.rerender('d18913de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GzPYln3VwOYm/JS/comp/pricelist.vue"
export default component.exports